var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComDoc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1668 14.6663H3.8335C3.30306 14.6663 2.79436 14.4556 2.41928 14.0806C2.04421 13.7055 1.8335 13.1968 1.8335 12.6663V1.99967C1.8335 1.82286 1.90373 1.65329 2.02876 1.52827C2.15378 1.40325 2.32335 1.33301 2.50016 1.33301H11.8335C12.0103 1.33301 12.1799 1.40325 12.3049 1.52827C12.4299 1.65329 12.5002 1.82286 12.5002 1.99967V9.99967H15.1668V12.6663C15.1668 13.1968 14.9561 13.7055 14.581 14.0806C14.206 14.4556 13.6973 14.6663 13.1668 14.6663ZM12.5002 11.333V12.6663C12.5002 12.8432 12.5704 13.0127 12.6954 13.1377C12.8204 13.2628 12.99 13.333 13.1668 13.333C13.3436 13.333 13.5132 13.2628 13.6382 13.1377C13.7633 13.0127 13.8335 12.8432 13.8335 12.6663V11.333H12.5002ZM11.1668 13.333V2.66634H3.16683V12.6663C3.16683 12.8432 3.23707 13.0127 3.36209 13.1377C3.48712 13.2628 3.65669 13.333 3.8335 13.333H11.1668ZM4.50016 4.66634H9.8335V5.99967H4.50016V4.66634ZM4.50016 7.33301H9.8335V8.66634H4.50016V7.33301ZM4.50016 9.99967H7.8335V11.333H4.50016V9.99967Z",
    fill: "#133A9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComDoc);
export default __webpack_public_path__ + "static/media/comDoc.3ab73bb2b452bb2700063e80864023c9.svg";
export { ForwardRef as ReactComponent };